(function (ws) {
    'use strict';

    ws.views.invoiceCountryHelp = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .invoice-country-help-submit': 'invoiceCountryHelpSubmit',
            'click .invoice-country-help-cancel': 'cancelModal',
            'click .cntryHelp': 'openShipToCountryModal'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
        },

        invoiceCountryHelpSubmit: function(e) {
            console.log('submit');
        },

        cancelModal: function(e) {
            console.log('close');

            //this.eventAgg.trigger('invoiceCountryHelpModal' + 'close');
            ws.views.modal.prototype.closeModal.call(this);
        },

        openShipToCountryModal: function(e) {
            if ($(e.target).val() === 'multiple' && $('.shipTodec').val()) {
                this.eventAgg.trigger('shipToVat');
                this.closeModal();
                $('.customerPayerVatReg').addClass('hide');
            } else {
                let dynamicCntryTxt = $('.shipTodec option:selected').html();
                $('.dynamicCountryText').html(dynamicCntryTxt);
                $('.customerPayerVatReg').removeClass('hide');
            }
        }
    });
})(westcon);
